module.exports = __webpack_public_path__ + "static/img/brush.23f579ed.png";